export const SIGNAL_CARD_COLUMN_SPANS = [10, 7, 7];
export const SIGNALS_PAGE_PADDING_BOTTOM = 16;
export const SIGNALS_PAGE_TABS_ROW_HEIGHT = 58;
